/* eslint-disable camelcase,no-undef,no-plusplus */
const ajax = (
  post_type = 'post',
  template = 'post',
  displayElementsCallback = null,
  reorderElementsCallback = null,
) => {
  const $ajaxContainer = $('[data-ajax-load]');

  const loadMoreElements = (res) => {
    if (displayElementsCallback) {
      displayElementsCallback(res);
      return;
    }
    $ajaxContainer.append(res);
  };

  const renderFilteredElements = (res) => {
    if (reorderElementsCallback) {
      reorderElementsCallback(res);
      return;
    }
    $('[data-ajax-load]').empty().append(res);
  };

  const loadMorePosts = (actionTypes, $buttonWrapper) => {
    const { ajaxUrl, query } = main_scripts;

    const maxPages = +$ajaxContainer.data('ajax-pages');
    const actionType = $ajaxContainer.data('ajax-load');
    let page = +$ajaxContainer.data('ajaxPage');
    const action = actionTypes[actionType];
    const { term, taxonomy } = JSON.parse(query);

    if (!action) {
      throw new Error('No registered action found. Please check if valid action passed to ajax container.');
    }

    const data = {
      action,
      page,
      post_type,
      template,
    };

    if (term) {
      data.term = term;
    }

    if (taxonomy) {
      data.taxonomy = taxonomy;
    }

    $.ajax({
      url: ajaxUrl,
      data,
      type: 'GET',
      beforeSend: () => {
        $buttonWrapper.addClass('is-loading');
        $buttonWrapper.prop('disabled', true);
      },
      success: (res) => {
        if (res) {
          loadMoreElements(res);
          page++;
          $ajaxContainer.data('ajaxPage', page);
          $buttonWrapper.removeClass('is-loading');
          $buttonWrapper.prop('disabled', false);
          if (page === +maxPages) {
            $buttonWrapper.remove();
          }
        } else {
          $buttonWrapper.remove();
        }
      },
    });
  };

  const loadPostsOnClick = ($loadMoreButtonWrapper, actionTypes) => {
    const $button = $loadMoreButtonWrapper.find('button');
    $button.on('click', () => loadMorePosts(actionTypes, $loadMoreButtonWrapper));
  };

  const handleAjaxFormChange = ($form) => {
    const category_filter = $form.serializeArray();
    const { ajaxUrl, query } = main_scripts;
    const action = 'filter_posts';
    const { term, taxonomy } = JSON.parse(query);
    const loadingClass = 'loading-in-progress';

    if (!action) {
      throw new Error('No registered action found. Please check if valid action passed to ajax container.');
    }

    const data = {
      action,
      post_type,
      template,
      category_filter,
    };

    if (term) {
      data.term = term;
    }

    if (taxonomy) {
      data.taxonomy = taxonomy;
    }

    $.ajax({
      url: ajaxUrl,
      data,
      type: 'GET',
      beforeSend: () => {
        $ajaxContainer.addClass(loadingClass);
      },
      success: (res) => {
        if (res) {
          renderFilteredElements(res);
          $ajaxContainer.removeClass(loadingClass);
        }
      },
    });
  };

  const listenToAjaxFormChanges = ($form) => {
    $form.on('change', () => handleAjaxFormChange($form));
  };

  const init = () => {
    const actionTypes = {
      post: 'load_more',
      taxonomy: 'load_more_taxonomies',
    };

    const $loadMoreButtonWrapper = $('.js--load-more');
    if ($loadMoreButtonWrapper.length) {
      loadPostsOnClick($loadMoreButtonWrapper, actionTypes);
    }

    const $ajaxForm = $('[data-ajax-form-filters]');
    if ($ajaxForm.length) {
      listenToAjaxFormChanges($ajaxForm);
    }
  };

  if ($ajaxContainer.length) {
    init();
  }
};

export default ajax;
